import { message } from 'antd';
import { get } from 'lodash';
export function onChange({
  file,
  fileList
}) {
  if (!fileList.length) {
    this.setState({
      attachments: []
    });
    return;
  }
  const imageUrl = get(file, 'response.results[0].url') || '';
  const name = get(file, `originFileObj.name`, '');
  file.name = name;
  file.url = imageUrl;
  file.thumbUrl = imageUrl;

  // When >1 file is uploaded at once, this function function is called once
  // per file, in parallel. There are race conditions; e.g. one thread could
  // mark an attachment 'done' then another, that has an out-of-date copy of
  // the file in it's `fileList`, could change it back to 'pending', so the
  // user it never appears done.
  //
  // To solve this we only update an attachment's state if the change is
  // possible with up-to-date data. E.g. we don't decrease `percent` or change
  // the `status` from 'done' to not done, because these changes make no sense
  // and can only be the result of a race condition.
  //
  // NB a file in `attachments` might not have a corresponding entry in
  // `fileList` at all (if the file is new), and visa versa (if the file was
  // deleted), so we need to handle those cases.

  this.setState(({
    attachments
  }) => {
    if (!attachments.length) return {
      attachments: fileList
    };
    const attachmentsByUid = new Map(attachments.map(file => [file.uid, file]));
    return {
      attachments: fileList.map(newFile => {
        const oldFile = attachmentsByUid.get(newFile.uid);
        return !oldFile || newFile.percent > oldFile.percent || newFile.status === 'done' && oldFile.status !== 'done' || newFile.status === 'error' && oldFile.status !== 'error' ? newFile : oldFile;
      })
    };
  });
  if (file.status === 'done') {
    message.success(`${file.name} file uploaded successfully`);
  } else if (file.status === 'error') {
    message.error(`${file.name} file upload failed.`);
  }
}